import { FC } from 'react';
import { WrapperProps } from './StaticWrapper.types';

export const StaticWrapper: FC<WrapperProps> = ({ referencePath }) => {
  return <div dangerouslySetInnerHTML={{ __html: referencePath }} />;
};
